import { SxStyles } from 'types/styles';
import { basicTheme } from 'theme';

export const styles: SxStyles = {
  root: {
    width: '100%',
    height: '100%',
    borderRadius: 1,
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
  textarea: {
    flexGrow: 1,
    width: '100%',
    height: '100%',
    padding: 3,
    resize: 'none',
    border: '1px solid',
    borderColor: basicTheme.palette.mainPalette.disabled,
    borderRadius: 1,
    font: 'inherit',
    letterSpacing: 'inherit',
    '&::placeholder': {
      opacity: 1,
    },

    '&:hover': {
      borderColor: basicTheme.palette.mainPalette.mult50,
    },
    '&:focus-within': {
      outline: 'none',
    },
  },
  error: {
    borderColor: `${basicTheme.palette.systemPalette.red} !important`,
    '&:hover': {
      borderColor: `${basicTheme.palette.systemPalette.red} !important`,
    },
  },
  errorText: {
    color: basicTheme.palette.systemPalette.red,
    ml: 3,
    mt: 1,
  },
};
